module.exports = __webpack_public_path__ + "static/media/ly.d089645e.svg";